import React, { Component } from "react";
import { Link } from "react-router-dom";
import { slide as MyMenu } from "react-burger-menu";

import ValidBrowser from "../Utils/ValidBrowser";
import { testValidBrowser } from "../Utils/helpers";

import Auth from "./Auth";

import burger from "../img/burger.svg";
import homeLogo from "../img/home.svg";
import recordLogo from "../img/video-camera.svg";
import evaluateLogo from "../img/clap.svg";
import logoutLogo from "../img/power.svg";
import bugLogo from "../img/bug.svg";
import avatar from "../img/user-logo.svg";
import m4pLogo from "../img/m4pLogo.png";
import "../styles/Menu.css";

const style = {
  display: "flex",
  img: {
    width: "30px",
    height: "30px",
    position: "fixed",
    right: "20px",
    marginTop: "-10px"
  },
  accountImg: {
    border: "2px solid white",
    borderRadius: "20px",
    padding: "2px",
    width: "25px",
    height: "25px",
    position: "fixed",
    right: "20px",
    marginTop: "-10px"
  },
  disabled: {
    pointerEvents: "none",
    color: "red"
  },
  info: {
    display: "bloc",
    fontSize: ".7rem"
  },
  bug: {
    fontSize: ".8rem",
    position: "fixed",
    bottom: "50px",
    color: "#f26d00"
  },
  imgBug: {
    width: "20px",
    height: "20px",
    position: "fixed",
    right: "20px",
    marginTop: "-5px"
  }
};

export default class Menu extends Component {
  constructor (props) {
    super(props);

    this.state = {
      menuOpen: false
    };
  }

  // This keeps your state in sync with the opening/closing of the menu
  handleStateChange = (state) => {
    this.setState({menuOpen: state.isOpen});
  }

  handleClick = () => {
    this.setState({ menuOpen: false });
  };

  render() {
    const { user } = this.props;
    return (
      <div>
        <MyMenu
          right
          className="menu"
          isOpen={this.state.menuOpen}
          onStateChange={(state) => this.handleStateChange(state)}
          customBurgerIcon={<img src={burger} alt="menu-burger-svg" style={burger}/>}
        >
          <Link to="/" onClick={this.handleClick} style={style}>
            Accueil
            <img alt="home" src={homeLogo} style={style.img} />
          </Link>
          <ValidBrowser
            test={testValidBrowser}
            valid={
              <Link
                to="/record"
                className="bm-item"
                onClick={this.handleClick}
                style={style}
              >
                Enregistrer
                <img alt="camera" src={recordLogo} style={style.img} />
              </Link>
            }
            error={
              <Link to="/record" className="bm-item" style={style.disabled}>
                Enregistrer
                <img alt="camera" src={recordLogo} style={style.img} />
                <span style={style.info}>
                  <br />
                  Indisponible sur ce navigateur.
                </span>
              </Link>
            }
          />
          <Link to="/pitchs" onClick={this.handleClick} style={style}>
            Evaluer
            <img alt="clap" src={evaluateLogo} style={style.img} />
          </Link>
          <Link to="/profil/account" onClick={this.handleClick} style={style}>
            Mon compte
            <img
              alt="avatar"
              src={user.photoURL ? user.photoURL : avatar}
              style={style.accountImg}
            />
          </Link>
          
          <a href="https://www.linkedin.com/in/tperron/" target="_blank" rel="noopener noreferrer" onClick={this.handleClick}>
            Made4Pitch{" "}
            <img src={m4pLogo} style={style.img} alt="logo made4pitch" />
          </a>

          <div>
            <Auth onClick={this.handleClick} />
            <img alt="logout" src={logoutLogo} style={style.img} />
          </div>

          <a
            href={`mailto:${process.env.REACT_APP_SPEEKER_EMAIL}?subject=[SPEEKER BUG REPORT]`}
            onClick={this.handleClick}
            style={style.bug}
            target="_blank"
            rel="noopener noreferrer"
          >
            Signaler un dysfonctionnement
            <img alt="bug" src={bugLogo} style={style.imgBug} />
          </a>
        </MyMenu>
      </div>
    );
  }
}
